import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78df9b52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "area-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title flow-title" }, "送信した資料を再利用して送信する", -1))
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "area-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title flow-title" }, "資料を一件ずつ送信", -1))
const _hoisted_9 = { class: "breadcrumb" }
const _hoisted_10 = { class: "content has-background-contents shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StopSend = _resolveComponent("StopSend")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OuterMetadataInput = _resolveComponent("OuterMetadataInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.reuseFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_StopSend)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Breadcrumb, {
              list: _ctx.reuseList,
              pageNum: 2
            }, null, 8, ["list"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_StopSend)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Breadcrumb, {
              list: _ctx.list,
              pageNum: 2
            }, null, 8, ["list"])
          ])
        ])),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_OuterMetadataInput)
    ])
  ]))
}